import { TxSerialized } from '@root/entities/transaction'
import { WalletId } from '@root/entities/wallet'

import type { TradePrepareDumpTokensInstructionsCreateDto } from '@root/shared/api/TradeApi'

export interface DumpTokenInstruction {
  walletId: WalletId
  serializedTx: TxSerialized
  swapOrderId: string
}

export const fromDto = (
  dto: TradePrepareDumpTokensInstructionsCreateDto,
): DumpTokenInstruction => {
  return {
    ...dto,
    walletId: WalletId(dto.walletId),
    serializedTx: TxSerialized(dto.serializedTx),
  }
}

export const fromDtos = (
  dtos: Array<TradePrepareDumpTokensInstructionsCreateDto>,
): Array<DumpTokenInstruction> => {
  return dtos.map((dto) => fromDto(dto))
}
